var _defs, _path, _path2, _path3, _path4, _path5, _path6, _path7;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDochLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Ebene_1",
    "data-name": "Ebene 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 303.11 145.2",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #f29449;\n      }\n\n      .cls-2 {\n        fill: #004e31;\n      }\n    "))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M0,0v126c0,10.6,8.6,19.2,19.2,19.2h283.91V19.2c0-10.6-8.6-19.2-19.2-19.2H0Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M54.64,102.17h-8.73l.03-59.45h8.7c4.66,0,5.57,1.32,5.57,29.73s-.91,29.73-5.57,29.73M54.64,31.91h-23.24v81.07h23.24c18.64,0,21.94-2.9,21.94-40.53s-3.3-40.53-21.94-40.53"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M109.48,102.86c-4.66,0-6.88-1.43-6.88-30.41s2.22-30.41,6.88-30.41,6.99,1.42,6.99,30.41-2.22,30.41-6.99,30.41M109.48,31.22c-18.53,0-23.24,3.09-23.24,41.22s4.72,41.22,23.24,41.22,23.36-3.1,23.36-41.22-4.72-41.22-23.36-41.22"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M166.88,42.03c3.98,0,6.65,3.73,6.88,22.9h13.87c1.36,0,2.5-1.18,2.39-2.75-1.02-25.94-6.99-30.95-23.13-30.95-18.53,0-23.24,3.1-23.24,41.22s4.72,41.22,23.24,41.22c16.25,0,22.22-1.42,23.13-28.25.11-1.57-1.02-2.75-2.39-2.75h-13.87c-.23,20.05-2.78,20.19-6.88,20.19-4.66,0-6.88-1.43-6.88-30.41s2.22-30.41,6.88-30.41"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M241.84,31.91h-13.07v39.16h-11.54V31.91h-15.46v81.07h15.46v-29.14h11.54v29.14h15.46V34.37c0-1.38-1.14-2.46-2.39-2.46"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M269.57,31.91h-12.05v57.14c0,1.38,1.02,1.23,2.27,1.23h12.16v-55.91c0-1.38-1.14-2.46-2.39-2.46"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M269.57,100.5h-9.66c-1.36,0-2.39.98-2.39,2.16v8.25c0,1.18,1.02,2.06,2.39,2.06h9.66c1.36,0,2.39-.88,2.39-2.06v-8.35c0-1.18-1.02-2.06-2.39-2.06"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDochLogo);
export default __webpack_public_path__ + "static/media/Doch_Logo.0d8485ee5bbf4b0337878b901cff0122.svg";
export { ForwardRef as ReactComponent };